module.exports = __webpack_public_path__ + "img/1-1.ec6d501f.png";